<template>
  <div class="cp-copy" :class="{share: isShare}">
    <!-- <div v-if="isShare" class="title"></div> -->
    <!-- <div v-if="isShare" class="desc share">召集<span style="color: #990000">1位</span>兄弟，增加<span style="color: #990000">1次</span>抽奖机会</div> -->
    <div v-if="isDownload" class="desc">请在您的手机浏览器中打开此链接进行下载</div>
    <div v-if="isHome" class="desc">若您未安装微信，请下载微信后打开此链接参与活动</div>
    <input type="text" class="input" :class="{share: isShare}" v-model="copy" disabled>
    <div
      v-clipboard:copy="copy"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
      class="button"
    ></div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Close from '~/components/Close/close.vue';
import Alert from "~/components/Alert";

export default {
  name: 'copy',
  components: {Close},
  props: {
    copy: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHome: false,
      isDownload: false,
      isShare: false
    }
  },
  mounted() {
    this.isShare = /share/.test(this.copy);
    this.isDownload = /download/.test(this.copy);
    this.isHome = /index/.test(this.copy);
  },
  methods: {
    onCopy: function (e) {
      Alert('复制成功~')
    },
    onError: function (e) {
      Alert('复制失败!')
    },
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-copy
    position absolute
    width 6.66rem
    height 6.46rem
    background-image url('./images/copy.png')
    background-size: 6.66rem 5.76rem;
    background-repeat: no-repeat;
    background-position 0 0
    &.share
      height 4.42rem
      background-image url('./images/copy.png')
      background-size: 6.66rem 3.72rem;
      .input
        top 0.7rem
      .button
        top 1.84rem
    .desc
      font-size 0.24rem
      font-weight bold
      color #000
      width 100%
      text-align center
      display block
      margin-top 1.53rem
      &.share
        font-size 0.24rem
        margin-top 1.73rem
        line-height 1
    .input
      width 5.26rem
      height 0.75rem
      background-color #fff
      display block
      position absolute
      top 2.1rem
      left 0.7rem
      color #333
      font-size 0.22rem
      text-align center
      border 0.01rem solid #e1cbaa
      line-height 0.75rem
    .title
      width 2.15rem
      height 0.51rem
      background-size: 100% 100%;
      background-image url('./images/copy-title.png')
      background-repeat: no-repeat;
      position absolute
      top 0.62rem
      left 2.39rem
      animation fadeIn 0.3s ease
    .button
      width 2.32rem
      height 0.86rem
      background-size: 100% 100%;
      background-image url('./images/copy-btn.png')
      background-repeat: no-repeat;
      position absolute
      top 3.84rem
      left 50%
      margin-left -1.16rem
      animation fadeIn 0.3s ease

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
</style>
